<script setup lang="ts">
import { Edit, Plus } from '@element-plus/icons-vue';
// import SvgMessage from './svg/svg-message.vue';
// import SvgClient from './svg/svg-client.vue';
// import SvgTeaching from './svg/svg-teaching.vue';
import { userStore } from '@/store';
import AddCustomer from '@/views/customer/components/add.vue'
import Check from '@/views/settle/components/chekout.vue'
import { ref } from 'vue';
import drawerPersonalCenter from './modules/drawer-personal-center.vue';
import dialogModifyPassword from './modules/dialog-modify-password.vue';
import defaultAvatar from './svg/svg-avatar.svg';
import { useCommonStore } from '@/store';
const commonStore = useCommonStore()
const _userStore = userStore()


const addialog = ref(false)
const value = ref('')
const visible = ref(false)
const info = ref({})
const addCustomerFn = () => {
  info.value = {
    userName: '',
    phonenumber: '',
    sex: '0',
    sourceShop: '',
    birthDayTimeType: '',
    birthday: '',
    remark: '',
    avatar: ''
  }
  addialog.value = true
}

const checkOut = () => {
  visible.value = true
}

const searchCustomer = () => {
  console.log(1);
}

/** 个人中心 */
const drawerPersonalCenterRef = ref<InstanceType<typeof drawerPersonalCenter> | null>(null)
const menuList = [
  {
    title: '个人中心',
    icon: 'icon-a-lujing3',
    action: () => {
      drawerPersonalCenterRef.value!.show()
    }
  },
  {
    title: '修改密码',
    icon: 'icon-a-lujing2',
    action: () => {
      dialogModifyPasswordRef.value!.onEdit();
    }
  },
  {
    title: '退出',
    icon: 'icon-a-lujing1',
    action: _userStore.logout
  },
]

/** 修改密码 */
const dialogModifyPasswordRef = ref<InstanceType<typeof dialogModifyPassword> | null>(null)
</script>

<template>
  <div class="module_header overflow-hidden">
    <img :src="commonStore.base_url + commonStore.dataBrand + '/images/module-header.png'" alt="logo" class="hidden w-[165px] sm:block">

    <div class="h-[64px] flex items-center justify-between flex-1">
      <div>
        <!-- <el-input placeholder="顾客名称/手机号码/会员号" class="w-72 h-[32px]" v-model="value"
          @keyup.enter.native="searchCustomer" /> -->
        <el-button type="primary" size="small" :icon="Plus" plain class="mx-5" @click="addCustomerFn">新增顾客</el-button>
        <el-button type="primary" size="small" :icon="Edit" plain @click="checkOut">在线核销</el-button>
      </div>
      <el-dropdown trigger="click" popper-class="dropdown_header-menu">
        <el-button text class="h-auto py-0 px-[6px] text-left">
          <div class="grid gap-1 grid-cols-[42px_auto]">
            <img :src="_userStore.userInfo.avatar || defaultAvatar" alt="avatar"
              class="col-[1_/_2]  row-[1_/_3] size-[42px] rounded-full mr-[6px]">
            <span class="hidden col-[2_/_3] row-[1_/_2] text-[#333333] text-sm sm:block" >{{ _userStore.userInfo.userName }}</span>
            <p class="hidden col-[2_/_3] row-[2_/_3] text-[#666666] text-sm sm:block">{{ _userStore.userInfo.shopName
              }}/{{
                _userStore.userInfo.roles[0].roleName }}</p>
          </div>
        </el-button>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item @click="item.action" v-for="item in menuList" class="h-14">
              <div class=" w-64 h-9 items-center flex justify-between">
                {{ item.title }}
                <svgIcon :iconName="item.icon" :size="20" />
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
    <!-- 新增修改 -->
    <AddCustomer v-if="addialog" :show="addialog" :data="info" @close="addialog = false" />
    <Check :visi="visible" @close="visible = false"></Check>

    <!-- 个人中心 -->
    <drawerPersonalCenter ref="drawerPersonalCenterRef" />

    <!-- 修改密码 -->
    <dialogModifyPassword ref="dialogModifyPasswordRef" />
  </div>
</template>

<style lang="scss" scoped>
.module_header {
  background: #FFFFFF;
  display: flex;
  align-items: center;
}

.header_center {
  display: flex;
  align-items: center;

  li {
    display: flex;
    align-items: center;

    &:not(:last-child) {
      margin-right: 2vw;
    }

    span {
      white-space: nowrap;
      margin-left: 10px;
      font-size: 14px;
      line-height: 19.6px;
      color: #333333;
    }
  }
}


@media screen and (max-width:1348px) {
  .el-input {
    display: none;
  }
}
</style>
<style lang="scss">
.dropdown_header-menu {

  // top: 10px !important;
  .el-popper__arrow {
    display: none;
  }
}
</style>